import { render } from "./CardSixteen.vue?vue&type=template&id=49a2cfb5"
import script from "./CardSixteen.vue?vue&type=script&lang=js"
export * from "./CardSixteen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__